
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { TtPage } from "@/CodegenTypes";
import { apolloClient, mutations } from "@/apollo";
import { clone } from "lodash";
import { errorMutationNotification } from "@/utils";
import { useTranslation } from "@/store/translation";

@Component({

  components: {}
})
export default class RenameTTPageModal extends Vue {
  @Prop({ required: true }) page!: TtPage;
  @Prop({ required: true, default: false }) value!: boolean;
  selectedAppModeIndex = 0;
  form = this.getDefaultForm();

  t = (text: string) => useTranslation().$t(text);

  mounted() {
    this.form = this.getDefaultForm();
  }

  toggleModal(val: boolean) {
    this.$emit("input", val);
  }

  getDefaultForm() {
    return clone({
      name: this.page.name
    });
  }

  @Watch("page")
  resetForm() {
    this.form = this.getDefaultForm();
  }

  async handleSubmit() {
    try {
      const result = await apolloClient.mutate({
        mutation: mutations.renameTtPage,
        variables: {
          id: this.page.id,
          newName: this.form.name
        }
      });
      this.$emit("submit");
      this.toggleModal(false);
    } catch (err) {
      errorMutationNotification(err);
    }
  }
}
